import { useState, createContext, useContext } from 'react';
import { motion } from 'framer-motion';
import TransactionModal from "../modals/Transaction.modal"
import SubscriptionModal from "../modals/Subscription.modal"
import AlertModal from "../modals/Alert.modal"
import { FiX } from 'react-icons/fi';
import "../css/modal.wrapper.scss"

export const ModalContext = createContext()
export const useModal = () => useContext(ModalContext)
const emptyModalState = { name: undefined, data: undefined }

export const ModalProvider = (props) => {
    const [modal, setModal] = useState(emptyModalState)
    const [notifier, setNotifier] = useState([])

    const closeModal = () => setModal(emptyModalState)
    const showAlert = (message, confirm, action, buttonTexts) => setModal({ name: "alert", data: { message, confirm, action, buttonTexts } })

    // Toast notifications
    function notify(message, variant) {
        const id = Math.random() * 1000
        setNotifier(prv => [...prv, { message, variant, id }])
    }
    function deNotify(id) {
        const newQueue = notifier.filter(toast => toast.id !== id)
        setNotifier(newQueue)
    }

    function openModal(name, data) {
        switch (name) {
            case "transaction":
                return (
                    <Container className="transaction" title="Transaction details">
                        <TransactionModal data={data} />
                    </Container>
                )
            case "new_subscription":
                return (
                    <Container title="Create a new subscription">
                        <SubscriptionModal data={data} />
                    </Container>
                )
            case "alert":
                return (
                    <Container title="Are you sure?" closeButton={false} centerTitle clickOutToClose>
                        <AlertModal data={data} />
                    </Container>
                )
            default:
                return null;
        }
    }

    return (
        <ModalContext.Provider value={{ closeModal, setModal, notifier, notify, deNotify, showAlert }}>
            {
                //Should take an object with Object<{name, data}> or just a String<"name">
                modal.name ?? typeof modal === "string" ?
                    openModal(modal.name ?? modal, modal.data)
                    : null
            }
            {props.children}
        </ModalContext.Provider>
    );
}

function Container({ children, title, closeButton = true, centerTitle, clickOutToClose }) {
    const closeTrigger = "close-trigger"
    const { closeModal } = useModal()

    function handleOutsideClick(e) {
        // e.stopPropagation()
        const { name } = e.target.dataset
        if (name === closeTrigger && clickOutToClose) closeModal()
    }

    return (
        <div
            data-name={closeTrigger}
            onClick={handleOutsideClick}
            style={{ zIndex: 999 }}
            className="modal-wrapper bg-gray-800 bg-opacity-50 h-screen w-screen overflow-y-auto scrollbar grid place-items-center absolute px-2 left-0 top-0"
        >
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ type: 'spring', mass: 0.5 }}
                data-name={closeTrigger}
                className="w-full max-w-md"
            >
                <div className={`w-full max-w-md modal-container bg-white rounded-xl shadow-xl overflow-hidden`}>
                    <div className="flex items-center justify-between px-4 md:px-6 h-20 border-b">
                        <p className={`text-gray-600 uppercase text-sm font-medium tracking-wider flex-1 ${centerTitle && "text-center"}`}>{title}</p>
                        {
                            closeButton ?
                                <div className="border border-gray-300 w-8 h-8 grid place-items-center rounded-full cursor-pointer" onClick={() => closeModal()}>
                                    <FiX className="text-gray-600 w-5 h-5" />
                                </div>
                                : undefined
                        }
                    </div>
                    {children}
                </div>
            </motion.div>
        </div>
    )
}